package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class ClubPostDto(
    val id: String,
    val clubId: String,
    val authorId: String,
    val content: String,
    val likesCount: Int,
    val isLikedByMe: Boolean,
    val images: List<ClubPostImageDto>,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class ClubPostImageDto(
    val id: String,
    val imageUrl: String,
    val sortOrder: Int
)

@Serializable
data class ClubPostPageDto(
    val items: List<ClubPostDto>,
    val page: Int,
    val size: Int,
    val totalItems: Long,
    val totalPages: Int
)

@Serializable
data class CreateClubPostRequest(
    val content: String = "",
    val imageUrls: List<String> = emptyList()
)
